import Vue from 'vue';
import { gsap, Quad, Power3 } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

Vue.component('specs-component', {
    data() {
        return {
        };
    },

    mounted() {
        this.revealSpec();

        EventBus.$on('window-resize', () => {
            Vue.nextTick(() => {
                if (this.$root.isTablet) {
                    document.querySelectorAll('.chapter__specs-row').forEach(el => el.classList.remove('active'));
                    gsap.to('.chapter__spec-info-container', {
                        duration: 0.3,
                        height: 'auto',
                        ease: Quad.easeOut,
                    });
                }
                if (this.$root.isMobile) {
                    document.querySelectorAll('.chapter__specs-row').forEach(el => el.classList.remove('active'));
                    gsap.to('.chapter__spec-info-container', {
                        duration: 0.3,
                        height: '0',
                        ease: Quad.easeOut,
                    });
                }
            });
        });
    },

    methods: {
        /**
         * Toggles the spec active state
         *
         * @param {Event} event
         */
        toggleSpec(event) {
            if (this.$root.isMobile) {
                const specItem = event.currentTarget.parentElement;
                const specItemText = event.currentTarget.nextElementSibling;

                if (specItem.classList.contains('active')) {
                    specItem.classList.remove('active');
                    gsap.to(specItemText, {
                        duration: 0.3,
                        height: 0,
                        ease: Quad.easeOut,
                    });
                } else {
                    specItem.classList.add('active');
                    gsap.to(specItemText, {
                        duration: 0.3,
                        height: 'auto',
                        ease: Quad.easeOut,
                    });
                }
            }
        },

        revealSpec() {
            const elements = [...document.querySelectorAll('.chapter__specs')];

            elements.forEach((element, index) => {
                gsap.timeline({
                    scrollTrigger: {
                        trigger: element,
                        start: "top 88%",
                        onEnter: () => {
                            gsap.to('.chapter__specs-row', { duration: 0.5, y: '0', autoAlpha: 1, ease: Power3.ease, stagger: 0.1 });
                        }
                    },
                });
            });
        },
    },
});